import React from 'react';

const CarStatusAvailable = () => {
  return (
    <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
      <ellipse cx="6.15419" cy="6.35641" rx="6.15419" ry="5.7175" fill="#5AD366" />
    </svg>
  );
};

export default CarStatusAvailable;
